<template>
  <div class="change-password">
    <el-card class="password-card">
      <div slot="header">
        <span class="card-title">修改密码</span>
      </div>
      
      <el-form 
        :model="passwordForm" 
        :rules="rules" 
        ref="passwordForm" 
        label-width="100px"
        size="medium">
        
        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="请输入原密码"
            show-password>
          </el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
            @input="checkPasswordStrength">
          </el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button 
            type="primary" 
            :loading="loading"
            @click="submitForm('passwordForm')">
            确认修改
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { Button } from "element-ui";
export default {
  name: 'ChangePassword',
  components: {
    'el-button': Button
  },
  data() {
    // 确认密码的验证规则
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    
    return {
      loading: false,
      passwordStrength: 0, // 密码强度（1-3）
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        //   { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' },
        //   { 
        //     pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
        //     message: '密码必须包含大小写字母和数字，长度8-16位',
        //     trigger: 'blur'
        //   }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    strengthText() {
      const texts = ['弱', '中', '强']
      return texts[this.passwordStrength - 1] || ''
    }
  },
  methods: {
    // 检查密码强度
    checkPasswordStrength(password) {
      let strength = 0
      // 检查长度
      if (password.length >= 8) strength++
      // 检查是否包含数字和字母
      if (/(?=.*[a-zA-Z])(?=.*\d)/.test(password)) strength++
      // 检查是否包含特殊字符
      if (/[!@#$%^&*]/.test(password)) strength++
      
      this.passwordStrength = strength
    },
    
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$http.post('api/user/changepwd',{
            oldpassword: this.passwordForm.oldPassword,
            newpassword:this.passwordForm.newPassword,
            renewpassword:this.passwordForm.newPassword,
          }).then(() => {
            this.loading = false
            this.$message.success('密码修改成功')
            this.resetForm(formName)
          })
        } else {
          return false
        }
      })
    },
    
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.passwordStrength = 0
    }
  }
}
</script>

<style scoped>
.change-password {
  max-width: 600px;
  margin: 20px auto;
}

.password-card {
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
}

.password-strength {
  margin-top: 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.strength-bars {
  display: flex;
  gap: 4px;
  margin: 0 8px;
}

.strength-bar {
  width: 30px;
  height: 4px;
  background: #E5E5E5;
  border-radius: 2px;
}

.strength-bar.active:nth-child(1) {
  background: #F56C6C;
}

.strength-bar.active:nth-child(2) {
  background: #E6A23C;
}

.strength-bar.active:nth-child(3) {
  background: #67C23A;
}

.strength-text {
  color: #909399;
}
</style>